import { useSubject } from '@base/utils/helpers';
import React from 'react';
import { container } from 'tsyringe';
import { IPlayersOnlineRepository } from '../player/model/interfaces';
import inImg from './assets/images/in.svg';
import outImg from './assets/images/out.svg';

export const LastInOutPlayer = () => {
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const last = useSubject(playersOnlineRepository.onInOutPlayer);

  if (!last) return null;

  return (
    <div className="last-player-wrap">
      <div className="last-player__status ">
        <img src={last.status === 'in' ? inImg : outImg} alt={last.status} />
      </div>
      <div className="last-player__name">{last.name || ''}</div>
    </div>
  );
};
